export default (apiFetch) => async (data) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(data)) {
    if (key === "studentId") {
      if (data.studentId !== undefined) {
        formData.append("file", data.studentId, data.studentId.name);
      }
    } else {
      formData.append(`${key}`, value);
    }
  }

  const response = await apiFetch({
    endpoint: "register",
    method: "POST",
    body: formData,
    nonce,
    headers: {},
  });

  return await response.json();
};
